import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Font = 'poppins' | 'inter' | 'roboto' | 'opensans';

interface FontState {
  font: Font;
  setFont: (font: Font) => void;
}

export const useFontStore = create<FontState>()(
  persist(
    (set) => ({
      font: 'poppins',
      setFont: (font) => {
        const validFonts = ['poppins', 'inter', 'roboto', 'opensans'];
        if (!validFonts.includes(font)) {
          console.error(`Invalid font: ${font}`);
          return;
        }
        
        try {
          // Remove all font classes
          document.body.classList.remove('font-poppins', 'font-inter', 'font-roboto', 'font-opensans');
          // Add the new font class
          document.body.classList.add(`font-${font}`);
          set({ font });
        } catch (error) {
          console.error('Error setting font:', error);
        }
      },
    }),
    {
      name: 'font-storage', // unique name for localStorage
    }
  )
);

// Initialize font on app load
if (typeof window !== 'undefined') {
  const initialFont = useFontStore.getState().font;
  useFontStore.getState().setFont(initialFont);
}